<template>

  <div>
    <div class = "e-title-card-box">
      <div class = "e-bread-box">
        <a-row>
          <a-col :span="21" >
            <a-menu v-model="current" mode="horizontal" @click="menuClick">

              <a-menu-item v-for="item in menus" :key="item.key" >
                <router-link :to="item.url" style="display: flex;    vertical-align: middle;    align-items: center;">
                  <!-- <a-icon :type='item.iconName' /> -->
                  <img :src="item.cIcon" alt="" class="e-img">
                  {{item.title}}
                </router-link>
              </a-menu-item>
            </a-menu>

          </a-col>
          <a-col :span="3">
            设备: {{this.device.DeviceName}}
          </a-col>
          <a-col :span="3">
            状态：{{this.device.Status=='ONLINE'?'在线':'离线'}}
          </a-col>
        </a-row>

      </div>
      <!-- <div class = "e-title-box">
        当前数据时间:2020-06-29 10:11:59
      </div> -->
    </div>

    <router-view></router-view>
  </div>

</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'

  export default {
    name: 'fishTypeForm',
    components: {
    },
    data() {
      return {
        current:'',// ['equipmentData'],
        menus:[],
        device:{},
        queryInfo:{
          productkey:"",
          devicename:"",
          keyword:"",cSystemCode:'设施园艺'
        },
        timer: '',//定时器
        // urls:{
        //   equipmentDataUrl:{},
        //   equipmentControlUrl:{},
        //   alarmEventsUrl:{},
        //   autoControlUrl:{},
        //   intelligentPushUrl:{},
        //   intelligentPredictionUrl:{},
        // }
      }
    },
  async  created(){
      this.menus=[
        {key:"equipmentData",cIcon:require("../../../equipmentimg/icon_27.png"),keyPath:["equipmentData"],title:"设备数据",url:{path:"/equipment/equipmentDetails",query:{IotId:this.getIotId}}},
        {key:"equipmentControl",cIcon:require("../../../equipmentimg/icon_32.png"),keyPath:["equipmentControl"],title:"设备控制",url:{path:"/equipment/equipmentDetails/equipmentControl/equipmentControlList",query:{IotId:this.getIotId}}},
        {key:"alarmEvents",cIcon:require("../../../equipmentimg/icon_29.png"),keyPath:["alarmEvents"],title:"报警事件",url:{path:"/equipment/equipmentDetails/alarmEvents/alarmEventsList",query:{IotId:this.getIotId}}},
        {key:"autoControl",cIcon:require("../../../equipmentimg/icon_40.png"),keyPath:["autoControl"],title:"自动控制",url:{path:"/equipment/equipmentDetails/autoControl/autoControlList",query:{IotId:this.getIotId}}},
        {key:"intelligentPush",cIcon:require("../../../equipmentimg/icon_38.png"),keyPath:["intelligentPush"],title:"智能推送",url:{path:"/equipment/equipmentDetails/intelligentPush/intelligentPushList",query:{IotId:this.getIotId}}}
      // {key:"intelligentPrediction",cIcon:require("../../../equipmentimg/1.png"),keyPath:["intelligentPrediction"],title:"智能预测",url:{path:"/equipment/equipmentDetails/intelligentPrediction/intelligentPrediction",query:{IotId:this.getIotId}}}
      ]
      this.current=this.menus[0].keyPath
this.IotId=this.$route.query.IotId;
    //  var device=this.$store.getters.Devices.filter(x=>x.IotId==this.getIotId)[0]

    console.log('this.$store.getters.User.enterprise.ID', this.$store.getters.User.enterprise.ID);
      let res = await this.$http.post('WLWDevice/List', {

        cEntID:this.$store.getters.User.enterprise.ID,cSystemCode:'设施园艺'
      })
      //  sceneId: this.$store.getters.SCene.ID  ,
      var device=res.data.obj.list;
    console.log('this.IotId', this.IotId);
      device=device.filter(x=>x.IotId==this.IotId)[0]

    console.log('device', device);

      if(device!=null) this.device=device
      this.queryInfo.productkey=this.device.ProductKey
      this.queryInfo.devicename=this.device.DeviceName
    console.log(' this.queryInfo.', this.queryInfo);
    },
    mounted(){
      this.timer= setInterval(this.getDevices, 10000);//定时10秒
    },
    methods:{
      menuClick({ item, key, keyPath }){
        //console.log(item, key, keyPath)
        this.current=keyPath
      },
      async getDevices(){
        const {data:res} = await this.$http.post('WLWDevice/List',this.queryInfo)
        if(res.code=="200"){
          if(res.obj.list.length>0){
            this.device=res.obj.list[0]
          }
        }
        else{

        }
      }
    },
    computed:{
      getIotId(){
        return this.$route.query.IotId
      }
    },
    beforeDestroy(){
      clearInterval(this.device.timer)
    }
  }
</script>

<style scoped>
  .e-img{
    height: 20px;
    width: 20px;
  }

  .e-title-card-box{
    background-color: #07294F;
    width:97%;
    margin-left: 18px;
    margin-bottom: 16px;
  }

  .e-bread-box{
    margin-left: 12px;
    padding-top: 16px;
    /*display: flex;*/
    /*justify-content: space-between;*/
    background-color: #07294F;
  }

  .e-title-box{
    margin-left: 12px;
    padding-bottom: 20px;
    padding-top: 20px;

    /*font-size: 130%;*/
    /*font-weight: bolder;*/
  }
</style>
<style>

  body{
    color:#ffffff;
  }.ant-select-selection {
    /* background-color: #0A2D57 !important;*/
   }
  .ant-input{
  /* color: #ffffff;*/
 }
</style>


